import { quickProperty, designToken } from '../component-tokens';
import { borderBase } from './common';
import { sizeAttributes } from './utils';
const alertAttrs = Object.assign(Object.assign({}, borderBase), { 'min-height': quickProperty('42px'), 'border-radius': quickProperty('4px'), display: quickProperty('flex'), 'align-items': quickProperty('flex-start'), padding: quickProperty('0 12px'), 'box-sizing': quickProperty('border-box'), color: designToken('text-01'), '--goto-icon-size': quickProperty('20px') });
const text = {
    alias: 'alert-text',
    name: 'text',
    attributes: {
        color: designToken('text-01'),
        font: designToken('body-small'),
        margin: quickProperty('0'),
        padding: quickProperty('8px 0'),
        'align-self': quickProperty('center'),
    },
};
const icon = {
    name: 'icon',
    attributes: Object.assign(Object.assign({}, sizeAttributes('20px')), { 'margin-right': quickProperty('8px'), 'margin-top': quickProperty('10px'), 'pointer-events': quickProperty('none') }),
};
export const alertTokens = {
    name: 'alert',
    attributes: alertAttrs,
    tag: 'chameleon-alert',
    reactImports: 'Alert',
    children: [text],
    variants: [
        {
            name: 'info',
            attributes: {
                'background-color': designToken('alert-background'),
                'border-color': designToken('alert-border'),
                '--goto-icon-color': designToken('interactive-01'),
            },
            children: [
                Object.assign(Object.assign({}, icon), { attributes: Object.assign(Object.assign({}, icon.attributes), { color: designToken('interactive-01') }) }),
                text,
            ],
        },
        {
            name: 'success',
            attributes: {
                'background-color': designToken('success-02'),
                'border-color': designToken('text-success-01'),
                '--goto-icon-color': designToken('text-success-01'),
            },
            children: [
                Object.assign(Object.assign({}, icon), { attributes: Object.assign(Object.assign({}, icon.attributes), { color: designToken('text-success-01') }) }),
                text,
            ],
        },
        {
            name: 'danger',
            attributes: {
                'background-color': designToken('danger-02'),
                'border-color': designToken('text-error-01'),
                '--goto-icon-color': designToken('text-error-01'),
            },
            children: [
                Object.assign(Object.assign({}, icon), { attributes: Object.assign(Object.assign({}, icon.attributes), { color: designToken('text-error-01') }) }),
                text,
            ],
        },
        {
            name: 'warning',
            attributes: {
                'background-color': designToken('warning-02'),
                'border-color': designToken('warning-01'),
                '--goto-icon-color': designToken('text-warning-01'),
            },
            children: [
                Object.assign(Object.assign({}, icon), { attributes: Object.assign(Object.assign({}, icon.attributes), { color: designToken('text-warning-01') }) }),
                text,
            ],
        },
    ],
};
export const alertVariants = alertTokens.variants.map((v) => v.name);
